export default __webpack_public_path__ + "static/media/ic_chat_grey.e6b72610.svg";